import { useDispatch } from '@/hooks/dispatch'
import { actionCreators } from '@/store/Dialogs'

const useDialog = () => {
  const [openDialog] = useDispatch([actionCreators.openDialog])
  return (options, id = null) => openDialog(options, id)
}

export {
  useDialog
}



// WEBPACK FOOTER //
// ./src/hooks/useDialog.js